import React, { useMemo, useRef, useState } from 'react';
import { useUnscrollableBody, useWindowDimensions } from '../../../../common/utils/windowDimensions';
import WebButton from '../WebButton/WebButton';
import Slider from 'react-slick';
import { Img, Portal, svgSprite } from '../../../../hybrid/wrappers';
import css from './GalleryBlock.module.scss';
import classNames from 'classnames';

const GalleryBlock = ({ template, block }) => {
    const [fullscreen, setFullscreen] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    useUnscrollableBody(fullscreen, 'GalleryBlock');
    const [imgForModalWindow, setImgForModalWindow] = useState([]);
    const slideElement = useRef(null);
    const widthDimensions = useWindowDimensions();
    const mobileSlider = useMemo(() => widthDimensions < 822, [widthDimensions]);
    const arrowStyles = useMemo(
        () => ({
            buttonArrow: css.buttonArrowColumn,
            arrowCircle: css.arrowCircleColumn,
            buttonArrowNext: css.buttonArrowNextColumn,
            buttonArrowPrev: css.buttonArrowPrevColumn
        }),
        []
    );
    const settings = useMemo(() => {
        if (template === 'templateleft' || template === 'templateright') {
            return {
                arrows: !fullscreen,
                nextArrow: <WebButton compStyles={{ ...arrowStyles }} type='next' />,
                prevArrow: <WebButton compStyles={{ ...arrowStyles }} type='prev' />,
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1
            };
        }
        return {
            arrows: !fullscreen,
            nextArrow: <WebButton compStyles={{ ...arrowStyles }} type='next' />,
            prevArrow: <WebButton compStyles={{ ...arrowStyles }} type='prev' />,
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
    }, [arrowStyles, fullscreen, template]);
    const settingsPortal = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <WebButton compStyles={css} type='next' portal={true} />,
        prevArrow: <WebButton compStyles={css} type='prev' portal={true} />,
        initialSlide: currentSlide
    };
    return (
        <>
            {fullscreen ? (
                <Portal customClass={'positionImg createdpages-slider'} fullWidth={true}>
                    <Slider {...settingsPortal} ref={slideElement}>
                        {imgForModalWindow.length &&
                            imgForModalWindow.map((file) => {
                                return (
                                    <div
                                        className={classNames(css.sliderItemPortal, fullscreen ? css.imgPortal : css.imgHover)}
                                        key={`slider${file?.id}`}
                                        onClick={() => {
                                            setImgForModalWindow(block?.blockContent);
                                            setFullscreen(!fullscreen);
                                        }}
                                    >
                                        <Img
                                            style={{
                                                height: '100%',
                                                zIndex: 2,
                                                margin: '0 10px',
                                                borderRadius: '12px'
                                            }}
                                            src={file?.url || file?.preview}
                                        />
                                    </div>
                                );
                            })}
                    </Slider>
                </Portal>
            ) : null}
            <div className={'createdpages-slider'}>
                <Slider {...settings} ref={slideElement}>
                    {block?.blockContent?.length &&
                        block.blockContent.map((file, idx) => {
                            return (
                                <div
                                    className={classNames(
                                        css.sliderItem,
                                        mobileSlider ? css.mobileSliderImg : fullscreen ? '' : css.imgHover
                                    )}
                                    key={`slider${file.id}`}
                                    onClick={() => {
                                        setImgForModalWindow(block?.blockContent);
                                        setFullscreen(!fullscreen);
                                        setCurrentSlide(idx);
                                    }}
                                >
                                    <Img className={css.sliderImg} src={file.url || file.preview} />
                                    <div className={css.sliderImgPosition}>
                                        {svgSprite('zoom', {
                                            width: '64px',
                                            height: '64px',
                                            fill: 'var(--whiteColor)'
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                </Slider>
            </div>
        </>
    );
};
export default GalleryBlock;
// className='imgHover'
